import React from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash-es';
import { ZipLongDistanceConfirmScreen } from 'site-modules/shared/components/lead-form/unified-lead-form/views/form-view/zip-long-distance-confirm-screen/zip-long-distance-confirm-screen';
import { showZipLongDistanceConfirmScreen } from 'site-modules/shared/utils/lead-form/show-zip-long-distance-confirm-screen';
import { useZipLongDistanceConfirm } from 'site-modules/shared/components/lead-form/zip-long-distance-confirm/use-zip-long-distance-confirm';
import { InventoryEntities } from 'client/data/models/inventory';

export function WithZipLongDistanceConfirmView({
  children,
  inventory,
  zipCode = PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  submitButtonColor = 'blue-50',
  make = '',
  model = '',
  classes = '',
  creativeId = '',
  toggleDrawer = noop,
}) {
  const { setZipLongDistanceConfirm, showZipLongDistanceConfirm } = useZipLongDistanceConfirm();

  return showZipLongDistanceConfirmScreen({
    showZipLongDistanceConfirm,
    inventory,
  }) ? (
    <ZipLongDistanceConfirmScreen
      inventory={inventory}
      model={model}
      make={make}
      onShowLeadForm={setZipLongDistanceConfirm}
      submitButtonColor={submitButtonColor}
      zipCode={zipCode}
      creativeId={creativeId}
      classes={classes}
      toggleDrawer={toggleDrawer}
    />
  ) : (
    children
  );
}

WithZipLongDistanceConfirmView.propTypes = {
  children: PropTypes.node.isRequired,
  inventory: InventoryEntities.InventoryVin.isRequired,
  zipCode: PropTypes.string,
  submitButtonColor: PropTypes.string,
  make: PropTypes.string,
  model: PropTypes.string,
  classes: PropTypes.string,
  creativeId: PropTypes.string,
  toggleDrawer: PropTypes.func,
};
